import { useCallback } from "react";
import { useAppNavigate } from "../global-hooks";
import { getAllPrivacyPolicy } from "../../actions/privacy-policy";
import {
  resetPrivacyPolicy,
  setPrivacyPolicyErrorMessage,
  setPrivacyPolicyPage,
  setPrivacyPolicyText,
} from "../reducers/privacy-policy.reducer";

export const useHandlePrivacyPolicyNavigateBack = (dispatch: Function) => {
  const navigate = useAppNavigate();
  const handleNavigateBack = useCallback(() => {
    dispatch(resetPrivacyPolicy());
    navigate("/privacy-policy");
  }, [dispatch, navigate]);
  return handleNavigateBack;
};

export const useHandlePrivacyPolicyTextChange = (dispatch: Function) => {
  const handleTextChange = useCallback(
    (text: string) => {
      dispatch(setPrivacyPolicyText(text));
    },
    [dispatch],
  );
  return handleTextChange;
};

export const useHandlePrivacyPolicyPageChange = (
  dispatch: Function,
  setState: Function,
) => {
  const handlePageChange = useCallback(
    (page: number) => {
      dispatch(setPrivacyPolicyPage(page));
      setState(false);
    },
    [dispatch, setState],
  );
  return handlePageChange;
};

export const useHandleGetAllPrivacyPolicy = () => {
  const getPrivacyPolicies = useCallback(async () => {
    await getAllPrivacyPolicy();
  }, []);
  return getPrivacyPolicies;
};

export const useHandlePrivacyPolicyAlertMessageChange = (
  dispatch: Function,
) => {
  const handleAlertMessage = useCallback(
    (message: string | null) => {
      dispatch(setPrivacyPolicyErrorMessage(message));
    },
    [dispatch],
  );
  return handleAlertMessage;
};
